import { Typography } from '@mui/material'
import {
  DatePicker,
  LabraToolTip,
  labraUIDateFormat,
} from '@labrav/react-components'
import { FormField } from '@labrav/react-components/lib/@types/types/forms'
import React, { useCallback } from 'react'
import { InfoOutlined } from '@mui/icons-material'
import { isEmpty } from 'lodash'
import clsx from 'clsx'
import { KeyValue } from '../../../modules/privateOffer/privateOfferCreation/types'
import { useStyles } from './ExpirationDate.styles'

export type ExpirationDateProps = {
  handleUpdateExpiration: (data: KeyValue) => void
  field: FormField
  tooltipLabel?: string
  errorHelperText?: string
}

export const ExpirationDate = React.memo(
  ({
    handleUpdateExpiration,
    errorHelperText,
    field,
    tooltipLabel,
  }: ExpirationDateProps) => {
    const { classes } = useStyles()
    const handleChange = useCallback(
      (date: string | null) => {
        handleUpdateExpiration({
          key: field.id,
          value: date || '',
        })
      },
      [field.id]
    )
    return (
      <div>
        <div className={classes.expirationDateContainer}>
          <Typography
            className={classes.subHeading}
            data-testid="expiration-date"
          >
            {field.humanReadableKey}
          </Typography>
          {tooltipLabel && (
            <LabraToolTip tooltipPlacement={'right'} label={tooltipLabel}>
              <InfoOutlined className={classes.infoIcon} />
            </LabraToolTip>
          )}
        </div>
        <div className={classes.dateFieldContainer}>
          <DatePicker
            format={labraUIDateFormat}
            field={field}
            key={field.id}
            handleDateChange={handleChange}
            errorHelperText={!isEmpty(errorHelperText) ? errorHelperText : ''}
            customClasses={clsx(classes.textField, classes.dateField)}
          />
        </div>
      </div>
    )
  }
)
